import type { FaireProductEntity } from "../../entity_types/product";

export const p_ruw8t5txm6: FaireProductEntity = {
  token: "p_ruw8t5txm6",
  type: "product",
  name: "Spooky Street 500 Piece Halloween Puzzle",
  brandToken: "b_nrc47wnxxn",
  brandName: "Puzzle Weekend",
  imageUrl:
    "https://cdn.faire.com/fastly/833f94c50e4307b23c7e7438c624063bf2e5b2594ef90d5ed5de1e0981239a09.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/064c6be16a113a10748f17ff59a29a377820fab96eeaf7c3bca43f0b4bd35896.webp",
    "https://cdn.faire.com/fastly/810ecb087131355249d15269f0f338f3fec49a844945d5175bfcd7e697012525.webp",
    "https://cdn.faire.com/fastly/b750658e6612bb6cc00cf4b3c7c39c807362f977747934974790c03650664444.webp",
    "https://cdn.faire.com/fastly/29a76c61f7b561eb04ec8e1f464a8122320a322e8865446bd2b89e6edafd221a.jpeg",
    "https://cdn.faire.com/fastly/4bd811fd0324808f91333794d43f3114ea025fe1627c1ef2d7d8b448233ca83e.webp",
    "https://cdn.faire.com/fastly/828b5df4f3fc5fda034b52e6123fa40dd15707ea09a1fd970e24c1cbb2fe9482.jpeg",
  ],
  priceDollars: 16,
  description:
    "This 500 piece Halloween puzzle by artist Nysha Lilly captures a charming bookstore and coffee shop nestled in a vibrant autumn setting. Above the inviting storefront, the apartments are alive with spooky characters—skeletons, witches, ghosts, mummies, and even Frankenstein and his bride can be seen through the windows. The building’s rooftop is home to a witch tending her greenhouse, adding a whimsical touch to this spooky scene.\n\n• 500 pieces\n• Random cut\n• Velvet-like soft touch coating\n• Artwork by © Nysha Lilly\n• Box Size: 10 x 8 x 2 inches\n• Completed Puzzle Size: 18 x 24 inches\n• Includes reference art insert + full puzzle image on box\n• Printed on Eska® 100% recycled puzzle board\n• Puzzle pieces are enclosed in a plastic bag. Please recycle at your local grocery store if possible.\n• Made in the USA",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:30.424Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
